<div class="flex flex-col gap-4">
	<p class="font-medium text-gray-950">Ensure Matter Accuracy</p>

	<p class="text-sm text-gray-700">
		Update intake status to let Closer know the client intake request has been
		sent to contacts on matter.
	</p>
</div>
